import {Component, Injector, OnInit} from '@angular/core';
import {EstudioService} from '../estudio.service';
import {GlmModalService} from '../../../_components/glm-modal/glm-modal.service';
import {CustomAlertService} from '../../../_components/custom-alert/custom-alert.service';
import {MatSnackBar } from '@angular/material/snack-bar';
import {EventoUnidad} from '../../../_models/evento-unidad';
import { GLMLanguageService } from 'src/app/_services/glm-language.service';

@Component({
  selector: 'meta-list',
  standalone: false,
  templateUrl: 'meta-criterios-list.component.html',
  styleUrls: ['meta-criterios-list.component.scss']
})

export class MetaCriteriosListComponent implements OnInit {

  metasCriterios: any[] = [];
  eventoID: number;
  evento: EventoUnidad;
  displayLang: string;

  guardando = false;

  constructor(private estudioService: EstudioService,
              private modalService: GlmModalService,
              private customAlertService: CustomAlertService,
              private injector: Injector,
              private snackBar: MatSnackBar,
              private languageService: GLMLanguageService) {
  }

  ngOnInit() {
    this.eventoID = this.injector.get('eventoID', []);
    this.evento = this.injector.get('evento', {});
    this.metasCriterios = this.injector.get('listaMetasCriterios', []).filter(meta => meta.categoria.ordenAgrupador !== 4);
    this.metasCriterios.map(metaCrit => {
      metaCrit['criteriosSeleccionados'] = metaCrit.criterios.filter(crit => crit.isConectado).length || 0;
    });

    this.displayLang = this.languageService.getCurrLanguage().activeLang.nickName;

    this.metasCriterios.forEach(meta => {
      meta.criterios.forEach(criterio => {
        if (criterio.idiomas.length > 0) {
          const curLang = criterio.idiomas.find(idioma => idioma.idioma === this.displayLang);
          if (curLang) {
            criterio.nombre = curLang.nombre;
          } else {
            criterio.nombre = criterio.idiomas[0].nombre;
          }
        }
      });
    });
  }

  cancelar() {
    this.modalService.cerrarModal();
  }

  cambiarEstado(evt, element, meta) {
    const modelo = {
      idParent: meta.id,
      idOrigen: this.eventoID,
      idDestino: element.id,
      estado: evt.checked
    };
    element.isConectado = evt.checked;
    this.estudioService.estadoEventoMeta(modelo).subscribe(() => {
      if (evt.checked) {
        meta.criteriosSeleccionados++;
        if (this.evento && this.evento.metas.findIndex(metaEv => {
          return +metaEv.id === +meta.id;
        }) < 0) {
          this.evento.metas.push(meta);
        }
      } else {
        meta.criteriosSeleccionados--;
        if (meta.criteriosSeleccionados === 0) {
          const metaIndex = this.evento.metas.findIndex(metaEv => {
            return +metaEv.id === +meta.id;
          });
          this.evento.metas.splice(metaIndex, 1);
        }
      }
      this.snackBar.open(
        `Se ha ${evt.checked ? '' : 'des'}conectado el criterio con el evento.`,
        null,
        {duration: 2250});
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible guardar la meta. <br> Código de error: ${err.statusText}`
      });
      element.isConectado = !evt.checked;
    });
  }

  parseString(text) {
    return new DOMParser().parseFromString(text, 'text/html').documentElement.textContent;
  }
}
